import { useCallback } from 'react';
import { useBackgroundQuery } from '@apollo-internal/hooks/useBackgroundQuery';
import GET_PRACTICE_AREA_REPORT from '../queries/getPracticeAreaReportQuery';

const GRAPHS_PER_PAGE = 3;

const useDataCorrelationPagination = selectedFilter => {
  const {
    data: practiceAreaReportData,
    loading: practiceAreaReportLoading,
    error: practiceAreaReportError,
    fetchMore
  } = useBackgroundQuery(GET_PRACTICE_AREA_REPORT, {
    skip: !selectedFilter.practiceAreaId || !selectedFilter.classificationMetricId,
    variables: {
      practiceAreaId: selectedFilter.practiceAreaId,
      continuationToken: {
        Offset: null,
        QualifiedPractices: null
      },
      limit: GRAPHS_PER_PAGE
    },
    notifyOnNetworkStatusChange: true
  });

  const continuationToken = practiceAreaReportData?.practiceAreaReport?.ContinuationToken;

  const fetchMoreData = useCallback(() => {
    fetchMore({
      variables: {
        practiceAreaId: selectedFilter.practiceAreaId,
        continuationToken: {
          Offset: continuationToken?.Offset,
          QualifiedPractices: continuationToken?.QualifiedPractices
        },
        limit: GRAPHS_PER_PAGE
      }
    });
  }, [
    continuationToken?.Offset,
    continuationToken?.QualifiedPractices,
    fetchMore,
    selectedFilter.practiceAreaId
  ]);

  return {
    practiceAreaReportsData: practiceAreaReportData?.practiceAreaReport?.PracticeReports,
    totalGraphCount:
      practiceAreaReportData?.practiceAreaReport?.ContinuationToken?.QualifiedPractices.length,
    practiceAreaReportLoading,
    practiceAreaReportError,
    fetchMoreData
  };
};

export default useDataCorrelationPagination;
